import HttpIntegration from "./integrations/HttpIntegration";
import App from "./App";

document.addEventListener("DOMContentLoaded", () => {
  App.init(new HttpIntegration());
});
